<template>
  <VOverlay
    :is-active="isOpen"
    :content-position="contentPosition"
    @click:outside="clickOutside"
  >
    <div class="overflow-scroll rounded-lg bg-cWhite">
      <div class="flex flex-col justify-between p-4" :class="classes">
        <slot />
      </div>
    </div>
  </VOverlay>
</template>

<script setup lang="ts">
  interface Props {
    isOpen?: boolean;
    minHeight?: 'auto' | 'md';
    contentPosition?: 'center' | 'bottom';
  }
  const props = withDefaults(defineProps<Props>(), {
    isOpen: false,
    minHeight: 'md',
    contentPosition: 'center',
  });

  const emit = defineEmits<{
    (e: 'update:isOpen', value: boolean): void;
    (e: 'click:outside', value: MouseEvent): void;
  }>();

  const classes = computed(() => ({
    'min-h-[212px]': props.minHeight === 'md',
  }));

  const clickOutside = (e: MouseEvent) => {
    emit('click:outside', e);
  };

  /**
   * ダイアログ展開時の背景スクロールの制御
   */
  const scrollTop = ref(0);
  const _onOpenDialog = () => {
    const $body = document.querySelector('body');
    if (!$body) return;
    scrollTop.value = window.scrollY;
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollTop.value}px`;
    $body.style.left = '0';
    $body.style.right = '0';
  };

  const _onCloseDialog = () => {
    const $body = document.querySelector('body');
    if (!$body) return;
    $body.style.position = '';
    $body.style.top = '';
    window.scrollTo({ top: scrollTop.value });
  };

  watch(
    () => props.isOpen,
    (open) => {
      if (open) _onOpenDialog();
      else _onCloseDialog();
    },
  );

  onBeforeUnmount(() => {
    _onCloseDialog();
  });
</script>
